/**
 * BaseTheme rework now uses javascript version ES6
 * ------
 *
 * Functions and Variables are no longer global and need to be imported
 * ( How to prepare function for export can be seen in `utils.js` )
 */
import { customEvents, initUtils } from './utils';
import { initMenu } from './menu';
import { initScroller } from './scroller';
import { setupFadeinSliders } from './fadein-slider';
import { initReviewsBlock } from './references-glide';
import { initMobileReviewsBlock } from './references-glide-mobile';
import { initHomeHeroGlide } from './home-hero-glide';
import { initVideoBlocks } from './block-video';
import { initPlatformsBlock } from './platforms-glide';
import { initOfficesBlock } from './offices-glide';
import { initContactOfficesBlock } from './contact-offices-glide';
import { initPeopleBlock } from './people-glide';
import { initCaseGliders } from './block-cases-slider';
import { initStickyNav } from './services-sticky-nav';
import { initStickyMobileArrow } from './services-mobile-nav';
import { initDropdowns } from './dropdowns';
import { initPeopleQuotesBlock } from './people-quotes-glide';
import { initQualificationBlock } from './career-qualification';
import { initBFLifeBlock } from './about/bflife';
import { initProcessBlock } from './career-process';
import { initShareButtons } from './block-sharer';
import { unleashFrankenstein } from './frankensteins_carousel';
import { resetGridbuidlerParams } from './gridbuilder-reset';
import { setupFOUCPreventer } from './gridbuilder-fouc-preventer';
import { initYoutubeEmbedDropdown } from './youtubeEmbedDropdown';
import { initIframeCSS } from './iframe-css';
import { initInfluencersBlock } from './influencers-glide';
import { initTestimonialsBlock } from './testimonials-glide';
//import { initCareerDropdowns } from './dropdowns-career' //unused in the end

/**
 * This function or DOMContentLoaded event is necesary for compiling to work
 *
 * Standalone functions will be removed on compile, so function that is called only in onclick event for example will be removed
 */

function initAllScripts() {
    initHomeHeroGlide();
    initUtils();
    initDropdowns();
    initMenu();
    initScroller();
    setupFadeinSliders();
    initReviewsBlock();
    initVideoBlocks();
    initPlatformsBlock();
    initOfficesBlock();
    initContactOfficesBlock();
    initPeopleBlock();
    initCaseGliders();
    initStickyNav();
    initPeopleQuotesBlock();
    initMobileReviewsBlock();
    initQualificationBlock();
    initProcessBlock();
    initBFLifeBlock();
    initStickyMobileArrow();
    initShareButtons();
    unleashFrankenstein();
    resetGridbuidlerParams();
    setupFOUCPreventer();
    //initCareerDropdowns(); //unused in the end.
    initYoutubeEmbedDropdown();
    initIframeCSS();
    initInfluencersBlock();
    initTestimonialsBlock();
}

if (document.readyState !== 'loading') {
    initAllScripts();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        initAllScripts();
    });
}
